import { common } from '../main/common-sidecar'
import { layers } from '../main/layers-sidecar'

export interface IStevieCam {
  controls: Phaser.Cameras.Controls.SmoothedKeyControl
  camera: Phaser.Cameras.Scene2D.Camera
  zoom: number
  // uiCamera: Phaser.Cameras.Scene2D.Camera
}

let _data: IStevieCam | null = null
export function get() {
  if (!_data) {
    _data = create()
  }
  return _data
}

function create() {
  let sc = common.getPhaserScene()
  // let scHud = common.getHudScene()

  // let uiCamera = scHud.cameras.main
  let camera = sc.cameras.main //sc.cameras.add(800 - 320, 20, 300, 300)
  // smallCamera.rotation = 0.2;
  camera.zoom = 1
  camera.setBackgroundColor('rgba(0, 0, 0, 1)')
  camera.setBounds(-2000, -2000, 10000, 10000)
  camera.x = 0
  camera.y = 0

  camera.originX = 0
  camera.originY = 0

  // camera.c
  let cursors = sc.input.keyboard.createCursorKeys()
  let controlConfig = {
    camera: camera,
    left: cursors.left,
    right: cursors.right,
    up: cursors.up,
    down: cursors.down,
    acceleration: 0.04,
    drag: 0.0005,
    maxSpeed: 0.7,
    zoomIn: sc.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.W),
    zoomOut: sc.input.keyboard.addKey(Phaser.Input.Keyboard.KeyCodes.R),
  }

  let controls = new Phaser.Cameras.Controls.SmoothedKeyControl(controlConfig)

  let stevieCam: IStevieCam = {
    controls,
    camera,
    zoom: 1,
    // uiCamera,
  }
  return stevieCam
}

export function shake() {
  let c = get()
  c.camera.shake(500)
}

let isMiddleDown = false
let mx = 0
let my = 0
let sx = 0
let sy = 0
export function update() {
  let c = get()
  // console.log('update controls')
  c.controls.update(common.getUpdateDelta() * 1000)
  if (c.camera.zoom !== c.zoom) {
    c.zoom = c.camera.zoom
    layers.setZoom(c.zoom)
  }

  let ap = common.getPhaserScene().game.input.activePointer
  if (ap.middleButtonDown()) {
    if (!isMiddleDown) {
      isMiddleDown = true
      mx = ap.x
      my = ap.y
      sx = c.camera.scrollX
      sy = c.camera.scrollY
    }
    c.camera.scrollX = sx - (ap.x - mx) / c.zoom
    c.camera.scrollY = sy - (ap.y - my) / c.zoom
  } else {
    isMiddleDown = false
  }
}

export function setZoom(num: number) {
  let c = get()

  let change = -(c.camera.zoom - num)
  console.log('zoom change', change)
  c.camera.scrollX += common.getPhaserScene().sys.game.scale.width * change
  c.camera.scrollY += common.getPhaserScene().sys.game.scale.width * change
  // c.camera.scrollX = c.camera.scrollX * (1 - change)
  // c.camera.scrollY = c.camera.scrollY * (1 - change)

  c.zoom = num
  c.camera.zoom = num
  layers.setZoom(num)
}
export function getZoom() {
  return get().zoom
}

export function toggleZoom() {
  let c = get()
  if (c.zoom === 1) {
    setZoom(0.5)
  } else {
    setZoom(1)
  }
}

export function mouseWheelZoom(dir: number) {
  let c = get()

  if (dir > 0) {
    setZoom(0.5)
  } else {
    setZoom(1)
  }
}
